import { render, staticRenderFns } from "./lock_file_dropdown_item.vue?vue&type=template&id=4643690e"
import script from "./lock_file_dropdown_item.vue?vue&type=script&lang=js"
export * from "./lock_file_dropdown_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports